import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import getGameSlugs from './getGameSlugs';

export type BuildsSpecPageSlugsViewModel = {
  gameSlug: string;
  specSlug: string;
  classSlug: string;
  zoneTypeSlug: string;
  categorySlug: string;
  difficultySlug: string;
  encounterSlug: string;
  affixesSlug?: string | null;
};

async function getBuildsSpecPageSlugs(): Promise<
  BuildsSpecPageSlugsViewModel[]
> {
  const gameSlugs = await getGameSlugs();

  return (
    await Promise.all(
      gameSlugs.map(async (gameSlug) => {
        const data = await fetchJsonFromRpgLogsApi(
          `query {
  viewModels {
    buildsSpecPageSlugs
  }
}`,
          {},
          gameSlug
        );

        return data.viewModels.buildsSpecPageSlugs;
      })
    )
  ).reduce((x, y) => x.concat(y), []);
}

export default getBuildsSpecPageSlugs;
